import type { SubscriptionPublicResponse } from '~/types/api'
import type { DeepReadonly } from 'vue'

export const tenantKey = Symbol() as InjectionKey<{
    tenant: DeepReadonly<Ref<SubscriptionPublicResponse>>;
    refresh: () => Promise<void>;
}>
